export default function ToggleChartView({ view, onClick }) {
  return (
    <button className="btn-small" onClick={() => onClick()}>
      <i className="material-icons center">{view == 'list' ? 'view_list' : 'insert_chart'}</i>
    </button>
  )
}
